import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../networking/client';
import { RootState } from '../store';
import { toast } from 'react-toastify';

export interface Gender {
  gender_id: number;
  gender: string;
}

export interface GendersState {
  status: string;
  genders: Gender[];
}

const initialState: GendersState = {
  status: 'idle',
  genders: [],
};

export const fetchGenders = createAsyncThunk(
  'genders/fetchAll',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const gendersResponse: any = await client.get('/healthpoint/genders');
      return gendersResponse;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? {});
    }
  }
);

export const gendersSlice = createSlice({
  name: 'genders',
  initialState,
  reducers: {
    resetGenders: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGenders.pending, (state) => {
        state.status = 'pending';
      })
      .addCase(fetchGenders.fulfilled, (state, action) => {
        state.genders = action.payload.data.genders;
        state.status = 'fulfilled';
      })
      .addCase(fetchGenders.rejected, (state, action: any) => {
        toast.error(action?.payload?.error ?? 'Something went wrong.', {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        state.status = 'rejected';
      });
  },
});

export const { resetGenders } = gendersSlice.actions;

export default gendersSlice.reducer;

export const selectGenders = (state: RootState) => state.genders.genders;
export const selectGenderStatus = (state: RootState) => state.genders.status;
